import React from 'react';
const withSuspence = (WrappedComponent, fallback) => props => (
  <React.Suspense fallback={fallback}>
    <WrappedComponent {...props} />
  </React.Suspense>
);

export default withSuspence;
